/** Polling interval for agent pool + ops admin live views (matches processor/singlecam). */
export const AGENT_POOLS_LIVE_REFETCH_MS = 15_000;
